<template>
    <div class="searchForm">
    <div class="searchTitle">
    <strong>探索勃艮第</strong>
    </div>
    <div class="searchFormFields">
    <form
        id="searchform"
        class="sf_widget"
    >
        <div class="searchBox">
        <label><strong>关键字</strong></label>
        <input
            id="keyword"
            name="search"
            type="text"
            placeholder="探索勃艮第"
            autocomplete="off"
        >
        </div>
        <label>
        <strong>条件</strong>
        </label>
        <select name="vintage" id="vintage" placeholder='年份' class="wide">
        <!-- <option data-display="Select">Nothing</option>
        <option value="1">Some option</option>
        <option value="2">Another option</option>
        <option value="3">Potato</option> -->
        </select>

        <select name="producer" id="producer"  class="wide"></select>

        <select name="village" id="village"  class="wide"></select>

        <p>
        <input type="button" value="查询" @click="hreftwo" class="btn">
        </p>
        <p>
        <a href="index.html#/insideburgundy">
            <strong>高级搜索</strong>
        </a>
        </p>
    </form>
    </div>
</div>
</template>
<script>
import ajax from '../ajax'
export default {
    name:'searchbox',
    mounted() {
      $('select').niceSelect()
    this.getselectdata()
  },
  methods: {
    getselectdata(){
      ajax.getvintage().then(res=>{
        this.showhtml('#vintage',res.data)
      })
      ajax.getproducer().then(res=>{
         this.showhtml('#producer',res.data)
      })
      ajax.getvillage().then(res=>{
         this.showhtml('#village',res.data)
      })
    },
    getquery(){
      let list = ['keyword','vintage','producer','village'];
      let query = {};
      list.forEach(item=>{
        query[item] = $(`#${item}`).val()
      });
      return query
    },
    showhtml(id,data){
        let arr = data.map(item=>`<option value="${item}">${item}</option>`)
        $(id).html(arr.join('')).niceSelect('update')
    },
    hreftwo() {
      window.SearchQuery = this.getquery()
      // if(window.SearchQuery.keyword){
        this.$router.push({ path: "./insideburgundy" });
      // }else{
      //   alert('请输入关键字进行查询！')
      // }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/template/search.vue